// extracted by mini-css-extract-plugin
module.exports = {"email":"style_email__1XH47"};